import { Box, Button, CardMedia, CircularProgress, Dialog, DialogActions, DialogContent, Grid, Skeleton, Theme, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import { DownloadFormIcon, UploadIcon } from "../../../../assets/SvgIcons";
import { useState } from "react";
import { useHistory } from 'react-router';
import { formatFileSize, isModuleAllowed, toINR } from "../../../../utils/utilityFunctions";
import { downloadMandateForm, proceedMandateForm } from "../../../../redux-store/actions/investorProfile";
import { useDispatch, useSelector } from "react-redux";
import { DownloadFormRes, FileID, ProceedMandateFormRes } from "../../../../redux-store/types/investorProfile";
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import { RootStateType } from "../../../../redux-store/reducers";
import { IMAGE_UPLOAD_FORMATS, USER_ROLES } from "../../../../utils/constant";
import BreadCrum from "../../../../lib/BreadCrum";
import { navigationData } from "../../types";
import { LoadingButton } from "@mui/lab";
import { logout, showError } from "../../../../redux-store/actions/auth";

registerPlugin(
    FilePondPluginImageExifOrientation,
    FilePondPluginImagePreview,
    FilePondPluginFileValidateSize,
    FilePondPluginFileValidateType
);


interface Instruction {
    name: string;
}

type CardProps = {
    mandateId: string,
    months: string,
    mandateType: string,
    amount: string,
    accountNo: string,
    ifscCode: string,
    bankName: string,
    status: string,
    fileKey: number,
    clientCode: string,
}


export default function DownloadUploadXSIP(): JSX.Element {
    const history = useHistory();
    const {
        role = '',
        permissions = []
    } = useSelector((store: RootStateType) => store.auth);
    const {
        selectedPortfolio
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const { pathname: pathName } = history.location;
    const [filehref, setFileHref] = useState<string>('');
    const dispatch = useDispatch();
    const [files, setFiles] = useState<any>([]);
    const authToken = useSelector((store: RootStateType) => store.auth.token);
    const [fileUploadId, setFileUploadId] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [formDownloadLoading, setFormDownloadLoading] = useState<boolean>(false);

    const { state } = history.location;
    const navState = state as navigationData


    const acceptedFileTypes = ['pdf', 'jpeg', 'jpg'];

    const instructions = [
        {
            "name": "Download Physical Mandate Form"
        },
        {
            "name": "Print it"
        },
        {
            "name": "Sign it"
        },
        {
            "name": "Take a picture of it"
        },
        {
            "name": "Upload the Picture"
        }
    ]

    const downloadUploadFixture: CardProps = (state as { downloadUploadFixture?: CardProps })?.downloadUploadFixture ?? {
        mandateId: '',
        months: '',
        mandateType: '',
        amount: '',
        accountNo: '',
        ifscCode: '',
        bankName: '',
        status: '',
        fileKey: 0,
        clientCode: ''
    }

    const [proceedDialogVisible, setProceedDialogVisible] = useState<boolean>(false);

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    const handleDownloadForm = async () => {
        try {
            setFormDownloadLoading(true);
            const fileDownloadRes = await (dispatch(downloadMandateForm({ fileId: downloadUploadFixture?.fileKey })) as unknown as Promise<DownloadFormRes>);

            if (fileDownloadRes?.url) {
                const link = document.createElement('a');
                link.href = fileDownloadRes.url;
                link.download = 'mandate_form.pdf';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (e) {
            console.log("FILE DOWNLOAD ERROR", e);
        } finally {
            setFormDownloadLoading(false);
        }

    }

    const handleProceedApiIntegration = async () => {
        const proceedBtnPayload = {
            mandateId: downloadUploadFixture?.mandateId,
            mandateType: downloadUploadFixture?.mandateType,
            clientCode: downloadUploadFixture?.clientCode,
            sponserBankCode: "FINLOGIC",
            utilityCode: "YESB00709000028661",
            fileId: fileUploadId
        }

        try {
            setLoading(true);
            const proceedMandateFormRes = await (dispatch(proceedMandateForm(proceedBtnPayload)) as unknown as Promise<ProceedMandateFormRes>);

            if (proceedMandateFormRes?.isSuccess) {
                setProceedDialogVisible(true);
            }
            else {
                throw new Error("Mandate Form Uploading Failed");
            }
        } catch (e) {
            console.log("PROCEED API ERROR", e);
        } finally {
            setLoading(false);
        }
    }

    const handleUploadDialog = () => {
        setProceedDialogVisible(false)

        const newPathName = pathName.split("/").slice(0, -1).join("/");
        history.replace({ pathname: newPathName, search: `?tab=Manage Mandates`, state: { formUploaded: true, clientCode: downloadUploadFixture?.clientCode } })
    }

    const initialRouter = pathName.split('/').filter((item) => item !== '')

    // console.log('path', initialRouter, pathName)

    const rmRouterPath = (isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? [
        {
            name: 'Dashboard',
            path: '/dashboard',
            // warning: true
        },
        {
            name: initialRouter[1] + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode: navState?.clientCode || ""
            }
        },
        {
            name: 'Mutual Funds',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode: navState?.clientCode || ""
            },
            search: '?tab=Manage Mandates'
        },
        {
            name: 'Download & Upload Physical Mandate Form',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
            state: {
                clientCode: navState?.clientCode || ""
            }
        }
    ] : [])

    const investorRouterPath = [
        {
            name: 'Dashboard' + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: '/investor-dashboard',
            // warning: true
        },
        {
            name: 'Mutual Funds',
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode: navState?.clientCode || ""
            },
            search: '?tab=Manage Mandates'
        },
        {
            name: 'Download & Upload Physical Mandate Form',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode: navState?.clientCode || ""
            }
        }
    ]

    return (
        <>
            <Box>
                <BreadCrum array={![USER_ROLES.INVESTOR].includes(role) ? rmRouterPath : investorRouterPath} />
            </Box>
            <Typography variant="h1" color={'text.primary'} sx={{ lineHeight: '32.5px', mb: '25px', mt: '20px' }}>Download & Upload Physical Mandate Form</Typography>
            <Grid container columnSpacing={3}>

                {/* Instructions grid  */}
                <Grid item xs={12} sm={8}>
                    <Box sx={(theme: Theme) => ({
                        padding: '35px 30px',
                        borderRadius: '20px',
                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                        background: theme.palette.common.white
                    })}>
                        <Box sx={{ mb: '25px' }}>
                            <Box>
                                <Box sx={(theme: Theme) => ({ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', columnGap: '15px', padding: '25px', background: theme.palette.grey[50] })}>
                                    <CardMedia
                                        component="img"
                                        src='/images/amcIcons/default.svg'
                                        sx={{ width: '45px', height: '45px' }}
                                    />
                                    <Box sx={{ flex: 1 }}>

                                        <>
                                            <Typography color={'text.secondary'} variant="body_500" sx={{ mb: '8px', lineHeight: '20px', letterSpacing: '0.02px' }}>Reference ID</Typography>
                                            <Typography color={'text.primary'} sx={{ fontWeight: '600', fontSize: '16px', lineHeight: '20px', letterSpacing: '0.02px' }}>{downloadUploadFixture?.mandateId}</Typography>
                                        </>


                                    </Box>
                                </Box>
                                <Box sx={(theme: Theme) => ({ padding: '25px', background: theme.palette.common.white })}>
                                    <Grid container columnSpacing={7} rowSpacing={3}>
                                        {/* Mandate type */}
                                        <Grid item xs={12} sm={6} md={3} sx={{ display: { xs: 'flex', sm: 'unset' }, justifyContent: 'space-between', alignItems: 'center' }}>

                                            <>
                                                <Typography color={'text.secondary'} variant="body_500" sx={{ mb: '8px', lineHeight: '20px', letterSpacing: '0.02px' }}>Mandate Type</Typography>
                                                <Typography color={'text.primary'} sx={{ fontWeight: '600', fontSize: '16px', lineHeight: '20px', letterSpacing: '0.02px' }}>{downloadUploadFixture?.mandateType === "X" ? "Physical Mandate" : "E-Mandate"}</Typography>
                                            </>

                                        </Grid>

                                        {/* Status */}
                                        <Grid item xs={12} sm={6} md={3} sx={{ display: { xs: 'flex', sm: 'unset' }, justifyContent: 'space-between', alignItems: 'center', }}>

                                            <>
                                                <Typography color={'text.secondary'} variant="body_500" sx={{ mb: '8px', lineHeight: '20px', letterSpacing: '0.02px', textAlign: { xs: 'right', md: 'unset' } }}>Status</Typography>
                                                <Typography color={'text.primary'} sx={(theme: Theme) => ({ fontWeight: '600', fontSize: '16px', lineHeight: '20px', letterSpacing: '0.02px', color: downloadUploadFixture?.status === "Under Process" ? theme.palette.warning[500] : theme.palette.success[500], textAlign: { xs: 'right', md: 'unset' } })}>{downloadUploadFixture?.status}</Typography>
                                            </>

                                        </Grid>

                                        {/* Mandate Limit */}
                                        <Grid item xs={12} sm={6} md={3} sx={{ display: { xs: 'flex', sm: 'unset' }, justifyContent: 'space-between', alignItems: 'center' }}>

                                            <>
                                                <Typography color={'text.secondary'} variant="body_500" sx={{ mb: '8px', lineHeight: '20px', letterSpacing: '0.02px' }}>Mandate Limit</Typography>
                                                <Typography color={'text.primary'} sx={{ fontWeight: '600', fontSize: '16px', lineHeight: '20px', letterSpacing: '0.02px' }}>{toINR({ value: downloadUploadFixture?.amount, locale, currencyCode })}</Typography>
                                            </>

                                        </Grid>

                                        {/* No. of months */}
                                        <Grid item xs={12} sm={6} md={3} sx={{ display: { xs: 'flex', sm: 'unset' }, justifyContent: 'space-between', alignItems: 'center' }}>

                                            <>
                                                <Typography color={'text.secondary'} variant="body_500" sx={{ mb: '8px', lineHeight: '20px', letterSpacing: '0.02px', textAlign: 'right' }}>No. of months</Typography>
                                                <Typography color={'text.primary'} sx={{ fontWeight: '600', fontSize: '16px', lineHeight: '20px', letterSpacing: '0.02px', textAlign: 'right' }}>{downloadUploadFixture?.months}</Typography>
                                            </>

                                        </Grid>
                                    </Grid>
                                </Box>

                            </Box>
                        </Box>

                        <hr />

                        <Box sx={{ mt: '25px' }}>
                            <Typography variant="h2" color={'text.primary'} sx={{ lineHeight: '25px', letterSpacing: '0.01px', mb: '25px' }}>
                                Instructions
                            </Typography>

                            {
                                instructions?.map((instruction: Instruction, index: number) => (
                                    <Typography variant="body_500" color={'text.secondary'} sx={{ lineHeight: '20px', letterSpacing: '0.01px', mb: '12px' }} key={index}>
                                        {index + 1}. {instruction?.name}
                                    </Typography>
                                ))
                            }
                        </Box>

                    </Box>
                </Grid>

                {/* Download Upload Grid */}
                <Grid item xs={12} sm={4} sx={{ mt: { xs: 3, md: 0 } }}>
                    <Box sx={(theme: Theme) => ({
                        padding: '25px 30px 35px 30px',
                        borderRadius: '20px',
                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                        background: theme.palette.common.white,

                        '.filepond--root': {
                            fontFamily: `${theme.typography.fontFamily}`,
                            border: `0.7px dashed ${theme.palette.text.disabled}`,
                            padding: { xs: '65px', sm: '80px', md: '90px', lg: '125px' },
                            borderRadius: '10px'
                        },
                        '.filepond--panel-root': {
                            background: theme.palette.common.white,
                        },
                        '.filepond--credits': { display: 'none' },
                        '.filepond-icon': { cursor: 'pointer' },
                        '.filepond--label-action': {
                            color: `${theme.palette.text.secondary}`,
                            fontFamily: `${theme.typography.fontFamily}`,
                            letterSpacing: '0.02px',
                            cursor: 'pointer',
                            textDecoration: "none",
                            fontSize: { xs: '14px', sm: '12px', md: '14px', lg: '16px' },
                            fontWeight: '500',
                            marginBottom: '8px'
                        },
                        '.filepond--label-format': {
                            color: `${theme.palette.text.secondary}`,
                            fontWeight: '400',
                            paddingLeft: '3px'
                        },
                        '.filepond-subheading': {
                            fontWeight: '400',
                            color: `${theme.palette.text.secondary}`,
                            fontSize: '12px'

                        },
                        '.filepond--drop-label': {
                            marginTop: { xs: '30px', sm: '40px', md: '60px', lg: '90px' },
                            cursor: 'pointer',
                            pointerEvents: 'all',

                        },
                        '.filepond--file': {
                            color: '#000',
                            flexWrap: 'wrap',
                            fontWeight: 500,
                        },
                        '.filepond--file-wrapper': {
                            backgroundColor: theme.palette.primary[50],
                        },
                        '.delete-icon-container': {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "primary.100",
                            borderRadius: "50%",
                            padding: "5px",
                            cursor: "pointer"
                        },
                        '.filepond--image-preview-overlay-success': {
                            color: theme.palette.primary[100],
                        },
                        "[data-filepond-item-state*= 'processing-complete'] .filepond--item-panel": {
                            backgroundColor: theme.palette.primary[50]
                        },
                        // "[data-filepond-item-state*= 'load-invalid'] .filepond--item-panel": {
                        //     backgroundColor: theme.palette.error[200],
                        // }
                    })}>
                        <FilePond
                            files={files}
                            server={{
                                process: {
                                    url: '/api/files/files',
                                    method: 'POST',
                                    headers: {
                                        Authorization: `Bearer ${authToken}`,
                                    },
                                    onload: (response): string => {
                                        const result = JSON.parse(response);
                                        setFileUploadId(result?.id);
                                        return response;
                                    },
                                },
                            }}
                            onupdatefiles={(fileItems) => {
                                console.log('fike', fileItems)
                                setFiles(fileItems);
                                setFileUploadId(0)
                            }}
                            onprocessfile={(error, file) => {
                                if (error) {
                                    if (error?.code === 401) {
                                        dispatch(showError(error?.body ?? ""))
                                        dispatch(logout());
                                    }
                                }
                            }}
                            name="file"
                            maxFileSize={'2MB'}
                            allowMultiple={false}
                            allowPaste={false}
                            maxFiles={1}
                            acceptedFileTypes={['application/pdf', 'image/jpeg', 'image/jpg']}
                            labelIdle={
                                `<div class="handle-label-orientation">
                                    <div class="filepond-icon"><img src="../../../images/uploadImg.svg" /></div>
                                    <div>
                                      <span class="filepond--label-action"
                                        >Click to Upload Image
                                      </span>
                                      <div class="filepond-subheading">
                                        Max Size 2MB
                                      </div>
                                      <div class="filepond-subheading">
                                      Supports pdf,jpg,jpeg
                                      </div>
                                    </div>
                                  </div>
                                  `}
                            labelFileTypeNotAllowed={'Invalid file type'}
                            fileValidateTypeLabelExpectedTypesMap={{
                                'application/pdf': '.pdf',
                                'image/jpeg': '.jpeg',
                                'image/jpg': '.jpg',
                            }}
                            imagePreviewHeight={100}
                            styleItemPanelAspectRatio="0.5"
                            iconRemove={`
                                  <div class="delete-icon-container">
                                    <img src="../../../images/delete-blue.svg"
                                  </div>
                                `}
                        />

                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mt: '35px', mb: '35px', columnGap: '10px' }}>
                            <DownloadFormIcon />
                            {formDownloadLoading && <CircularProgress color="inherit" size={15} />}
                            {!formDownloadLoading && <Typography onClick={handleDownloadForm} sx={(theme: Theme) => ({
                                color: theme.palette.primary[500],
                                lineHeight: '20px',
                                letterSpacing: '0.02px',
                                fontSize: '16px',
                                fontWeight: '600',
                                cursor: 'pointer'
                            })}>DOWNLOAD FORM
                            </Typography>}
                        </Box>

                        <Box sx={{ mb: '10px' }}>

                            <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}>
                                <Box component={'span'} sx={(theme) => ({
                                    width: '4px',
                                    height: '4px',
                                    borderRadius: '50%',
                                    backgroundColor: theme.palette.text.secondary,
                                })}></Box>
                                <Typography color={'text.secondary'} variant="subtitle_500" sx={{
                                    lineHeight: '17.5px',
                                    letterSpacing: '0.02px',
                                    fontSize: '12px'
                                }}>Upload Form: {downloadUploadFixture?.mandateId}</Typography>
                            </Box>

                        </Box>

                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}>
                                <Box component={'span'} sx={(theme) => ({
                                    width: '4px',
                                    height: '4px',
                                    borderRadius: '50%',
                                    backgroundColor: theme.palette.text.secondary,
                                })}></Box>
                                <Typography color={'text.secondary'} variant="subtitle_500" sx={{
                                    lineHeight: '17.5px',
                                    letterSpacing: '0.02px',
                                    fontSize: '12px'
                                }}>Please make sure the borders are visible in the image</Typography>
                            </Box>

                        </Box>

                        <Box sx={{ mt: '25px' }}>
                            <LoadingButton
                                loading={loading}
                                loadingPosition="start"
                                onClick={handleProceedApiIntegration}
                                variant="contained"
                                sx={(theme: Theme) => ({
                                    borderRadius: "10px",
                                    padding: "12px",
                                    backgroundColor: theme.palette.primary[500],
                                    color: theme.palette.textDark.primary,
                                    width: '100%',
                                    "&.Mui-disabled": {
                                        backgroundColor: `${theme.palette.text.secondary}B2`,
                                        color: theme.palette.text.secondary,
                                    },
                                })}
                                disabled={!(files[0]?.fileSize / (1024 * 1024) <= 2) || !acceptedFileTypes.includes(files?.[0]?.fileExtension)}

                            >
                                Proceed
                            </LoadingButton>
                        </Box>

                    </Box>
                </Grid>
            </Grid >
            <Dialog
                open={proceedDialogVisible}
                maxWidth='sm'
                fullWidth
                sx={{
                    '& .MuiPaper-root': {
                        borderRadius: '15px',
                        backgroundColor: "background.paper",
                        rowGap: "25px",
                    },
                }}
            >
                <DialogContent sx={{ paddingTop: "25px" }}>
                    <Box sx={{ display: "flex", columnGap: "8px" }}>
                        <Typography variant='h2' color="text.primary" mb="10px">{'Form Successfully Submitted'}</Typography>
                    </Box>

                    <Typography
                        component={'span'}
                        variant='subtitle_400'
                        color="text.secondary"
                        sx={{
                            lineHeight: "20px"
                        }}
                    >
                        {'The Physical Mandate form has been successfully submitted and awaits bank approval, which will take '}
                    </Typography>
                    <Typography
                        component={'span'}
                        variant='body_500'
                        sx={(theme: Theme) => ({
                            lineHeight: "20px",
                            color: theme.palette.primary[500]
                        })}
                    >
                        {'21 days.'}
                    </Typography>

                </DialogContent>
                <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
                    <Button
                        variant="contained"
                        sx={(theme: Theme) => ({
                            flex: 1,
                            color: theme.palette.textDark.primary,
                            padding: "10px"
                        })}
                        onClick={handleUploadDialog}
                    >
                        {'Done'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>

    )
}